import { useQuery } from "@tanstack/react-query";
import { API, api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { queryClient } from "@/lib/queryClient";

// Tenant effectif côté UI (affichage/clés de cache uniquement — le backend résout
// TOUJOURS le tenant depuis le token/session, jamais depuis le navigateur).
export const useTenantKey = () => {
  const { user, actAs } = useAuth();
  return actAs?.tenant || user?.tenant_id || "default";
};

// Requête GET partagée : clé = [tenant, chemin, params] → isolation stricte par tenant
// et par paramètres, déduplication des requêtes identiques en cours (react-query).
export const useApiQuery = (path, params = null, options = {}) => {
  const tenant = useTenantKey();
  const { timeout, ...rest } = options;
  return useQuery({
    queryKey: [tenant, path, params],
    queryFn: async ({ signal }) =>
      (await api.get(`${API}${path}`, { params: params || undefined, signal, timeout: timeout || 60000 })).data,
    ...rest,
  });
};

// Invalide toutes les requêtes d'un chemin pour un tenant (après une écriture).
export const invalidateApiPath = (tenant, path) =>
  queryClient.invalidateQueries({ queryKey: [tenant, path] });
